import { memo } from "react";
import { Handle, Position, NodeProps } from "@xyflow/react";
import {
  StyledRootNode,
  StyledRootNodeContent,
  StyledNodeAddButton,
  StyledNodeDetail,
  StyledNodeHover,
  StyledNodeTitle,
} from "./index.styled";
import { MessageBotNodeData, MessageBotNodesEnum } from "@lib/types/MessageBot";
import { useTypedDispatch } from "@lib/redux";
import { setAddNodeModal } from "@lib/redux/slices/messageBot";
import { messageBotNodeInfos } from "@lib/constants/MessageBot";

const RootNode = (props: NodeProps) => {
  const dispatch = useTypedDispatch();
  const { selected, id, type } = props;
  const nodeInfos = messageBotNodeInfos[MessageBotNodesEnum.ROOT];
  const { label } = props.data as MessageBotNodeData<MessageBotNodesEnum.ROOT>;

  return (
    <>
      <StyledRootNode selected={selected}>
        <Handle type="target" position={Position.Top} />
        <Handle type="target" position={Position.Left} />
        <Handle type="source" position={Position.Bottom} />
        <Handle type="target" position={Position.Right} />

        <StyledRootNodeContent
          selected={selected}
          width={nodeInfos.size.width}
          height={nodeInfos.size.height}
        >
          <StyledNodeTitle>{type}</StyledNodeTitle>
          <StyledNodeDetail>{label}</StyledNodeDetail>

          <StyledNodeHover className="node-actions">
            <StyledNodeAddButton
              size={8}
              onClick={() =>
                dispatch(
                  setAddNodeModal({
                    isOpen: true,
                    parentId: id,
                  }),
                )
              }
            />
          </StyledNodeHover>
        </StyledRootNodeContent>
      </StyledRootNode>
    </>
  );
};

export default memo(RootNode);
